import { useMemo } from 'react';
import { QuoteItemTypeCodeNames } from '@models/quotePanel';
import { useStructuredQuote } from '@services/quoteDetails';
import { useSearchFraudStatements } from '@services/fraud-statement';

export function useGetFraudStatement(quoteId: string) {
  const { structuredQuote } = useStructuredQuote(quoteId);
  const jurisdictionId = useMemo(() => {
    const [firstJurisdictionQuoteItem] =
      structuredQuote?.quoteItems
        ?.filter((el) => el.quoteItemType?.codeName === QuoteItemTypeCodeNames.Jurisdiction)
        // sort in ascending order:
        ?.sort(
          ({ instanceNumber: instanceNumberA }, { instanceNumber: instanceNumberB }) =>
            (instanceNumberA ?? 0) - (instanceNumberB ?? 0),
        ) ?? [];

    const jurisdictionId = firstJurisdictionQuoteItem?.attributeTypes.JurisdictionId.attribute?.value as string;

    return jurisdictionId;
  }, [structuredQuote]);

  const {
    items: [fraudStatement],
  } = useSearchFraudStatements({
    jurisdictionId,
  });

  return { fraudStatement };
}
